import React from 'react'
import { Broadcast } from 'react-broadcast'
import { Query } from 'react-apollo'
import graphqlQuery from 'graphs/queries/Company.graphql'

const CompanyProvider = ({ children, ...rest }) => (
  <Query query={graphqlQuery} {...rest}>
    {({ loading, data: { company } }) => (
      <Broadcast channel="company" value={{ loading, company }}>
        {children}
      </Broadcast>
    )}
  </Query>
)

export default CompanyProvider



// WEBPACK FOOTER //
// ./src/components/Company/Provider.js